import { render, staticRenderFns } from "./openNutritionSales.vue?vue&type=template&id=12c8d4b5"
import script from "./openNutritionSales.vue?vue&type=script&lang=js"
export * from "./openNutritionSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports